import { combineReducers } from "redux";
import theme from "./theme";
import user from "./user";
import cachedStatus from "./cachedStatus";

import codeManagement from "./codeManagement";
// import permissionManagement from "./permission-management/list";
import menuManagementRegist from "./menu-management/regist";
import notice from "./notice/index";
import top from "./top";
import join from "./join";
import settingPassword from "./setting/password";
import event from "./event";
import membership from "./membership/index";
import point from "./point";
import home from "./home";
import review from "./review";
import left from "./left";
import loading from "./loading";
import pay from "./pay";

const rootReducer = combineReducers({
  user,
  theme,
  codeManagement,
  cachedStatus,
  // permissionManagement,
  menuManagementRegist,
  notice,
  top,
  join,
  settingPassword,
  event,
  membership,
  point,
  home,
  review,
  left,
  loading,
  pay,
});

export default rootReducer;
